export const CUSTOMER_SCORE_EVENTS = {
  CONTACT_CREATED: 'create_contact', // sent from BE on InsertContact
  TASK_EXECUTED: 'execute_task', // sent from BE
  ENRICH_EMAIL_PHONE: 'enrich_email_phone', // fully managed by BE since the logic split between FE and extension and we can't use customerScore on extension yet
  REWRITE: 'rewrite',
  STRATEGY_UPDATE: 'sequence_update',
};

type TrackAnalytics = {
  track: (eventName: string, properties?: object) => void;
};

export function useCustomerScore(): TrackAnalytics | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return {
    track: (eventName: string, properties?: object): void => {
      try {
        if (
          window.CustomerScoreTracker &&
          typeof window.CustomerScoreTracker.track === 'function'
        ) {
          window.CustomerScoreTracker.track(eventName, properties);
        }
      } catch (error) {
        console.error('CustomerScoreTracker tracking failed:', error);
      }
    },
  };
}
